import Api from './api';

const slug = 'v1/programs';
export default {
  getPrograms() {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}`, {
        params: {
          sort: '-created_at',
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getProgram(programSlug, populate = false) {
    return new Promise((resolve, reject) => {
      const config = populate ? { populate: true } : {};
      Api.get(`/${slug}/${programSlug}`, {
        params: config,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createProgram(program) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}`, program)
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateProgram(program) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/update/${program._id}`, program)
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
  inviteUsers(payload) {
    return new Promise((resolve, reject) => {
      // TODO: Implement backend service
      // { role: string, emails: string[], program: string }
      Api.post('/v1/programs/invite/', payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  generateInviteLink(email, programSlug) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/invitation-link`, { email, programSlug })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  reSendInvite(userEmail, programSlug) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/resend-invitation-link`, {
        userEmail,
        programSlug,
      })
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
  notifyProgramMember(payload) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/notify-member`, payload)
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
  generateProgramReport(programSlug) {
    return Api.post(`/${slug}/${programSlug}/generate-report`, {}, { responseType: 'blob' })
      .then(response => response.data) // Ensure returning only `response.data` (blob)
      .catch((err) => {
        console.error('Error generating report:', err);
        throw err;
      });
  },
};
